<template functional>
  <div
    class="explanation-box"
    :class="data.staticClass || ''"
    v-bind="data.attrs"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ExplanationBox',
};
</script>

<style lang="scss">
@import '../../../sass/v2';
.explanation-box {
  font-style: italic;
  background-color: rgba(0, 88, 111, 0.1);
  padding: 10px 15px;
  border-radius: unset;
  text-align: center;
  @extend .v2_font_size_16;
}
</style>
